import * as React from "react";
import IDeletePopupProps from "./IDeletePopup";
import "../../../assets/sass/components/deletePopup.scss";
import { handleEnter, imagePathurl } from "../../utils/utils";
const DeletePopup: React.FC<IDeletePopupProps> = (props) => {
    const { popupStatus, popupTitle, popupDescription, buttonText, onConfirm, onCancel, tabIndex } = props;
    //image CDN_PATH
    const getimagePath = imagePathurl();
    return (
        <React.Fragment>
            <div className={popupStatus ? "form-container-block" : "form-container"} id="form-container">
                <div className="overlay" onClick={() => onCancel()}>
                    <div
                        className="popup-container"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div
                            id="close_popup"
                            className="close-menu"
                            onClick={() => onCancel()}
                            onKeyPress={handleEnter}
                        >
                            <img
                                tabIndex={tabIndex}
                                className="popup-close-icon"
                                src={`${getimagePath}close-mobile.png`}
                                alt="close"
                            />
                        </div>
                        <div className="popup-header-title">{popupTitle}</div>
                        <div className="popup-header-subtitle">{popupDescription}</div>
                        <div className="text-center">
                            <button
                                type="button"
                                tabIndex={tabIndex}
                                id="delete_popup"
                                className="popup-btn"
                                onClick={() => onConfirm()}
                                onKeyPress={handleEnter}
                            >
                                {buttonText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default DeletePopup;
